import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { FlexBox } from 'ml-rubiks-styleguide';
import { injectTSDI } from 'ml-webclient-common/src/tsdi';
import { FastFinanceLinkStore, isInstrumentNotRequired } from '../../store';
import { CreditCardDetails } from './credit-card-details';
import { DirectDebitDetails } from './direct-debit-details';
import { PaymentStatusBadge } from './status-badge';
export const PaymentMethodDetails = observer(function PaymentMethodDetails() {
    const store = injectTSDI(FastFinanceLinkStore);
    const paymentMethod = store.currentPaymentMethod;
    if (!paymentMethod) {
        return null;
    }
    const { paymentTypeDto, paymentInstrumentStatus } = paymentMethod;
    const effectiveStatus = paymentInstrumentStatus ??
        (isInstrumentNotRequired(paymentMethod.paymentMethod)
            ? 'CONFIRMED'
            : undefined);
    return (_jsxs(FlexBox, { stack: true, hAlign: "flex-start", children: [paymentTypeDto?.creditCardPaymentDto && (_jsx(CreditCardDetails, { creditCard: paymentTypeDto.creditCardPaymentDto })), paymentTypeDto?.directDebitPaymentDto && (_jsx(DirectDebitDetails, { directDebit: paymentTypeDto.directDebitPaymentDto })), _jsx(PaymentStatusBadge, { status: effectiveStatus })] }));
});
